import React, { useEffect } from 'react';
import { IconButton, TextButton } from '../../styles/button.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useVerificationStore } from '../../context/VerificationContext';
import { ReportMetadata } from '../../types/ViewModel/Verification/ReportMetadata';
import { canShowComponentForRole } from '../../utils/verification/verificationUtils';
import { useAuthStore } from '../../context/AuthContext';
import { prettifyDate } from 'odfjell-date-time-utils/dateTimeFormatter';
import { AcceptedWrapper, IssuesHeader } from '../../pages/verification/Verification.styles';
import { DNVReportStatus } from '../../enums/dnvReportStatusEnum';

type Props = {
    report: ReportMetadata;
    onChangeSort: () => void;
    onChangeShowDetails: () => void;
    isShowDetails: boolean;
    sortDesc: boolean;
};

const VerificationHeaderComponent: React.FC<Props> = (props) => {
    const { selectedReportMetadata } = useVerificationStore();
    const { isCommentExpanded, setIsCommentExpanded, showConfirmAccept, setShowConfirmAccept } = useVerificationStore();
    const { role } = useAuthStore();

    useEffect(() => {
        if (props.report) {
            setShowConfirmAccept(false);
        }
    }, [props.report]);

    const onConfirmAccept = () => {
        if (showConfirmAccept) {
            setShowConfirmAccept(false);
        } else {
            setShowConfirmAccept(true);
        }
    };

    const onUndoAccept = () => {
        setShowConfirmAccept(true);
    };

    const onToggleComment = () => {
        if (isCommentExpanded) {
            setIsCommentExpanded(false);
        } else {
            setIsCommentExpanded(true);
        }
    };

    const getUndoAcceptTooltip = (reportMetadata: ReportMetadata) => {
        return prettifyDate(reportMetadata.acceptedAt) + ' by ' + selectedReportMetadata.acceptedByUser;
    };

    const getAcceptTooltip = (reportMetadata: ReportMetadata) => {
        return reportMetadata.acceptedAt != null
            ? `Previously accepted by ${reportMetadata.acceptedByUser} at ${prettifyDate(reportMetadata.acceptedAt)}, but has new or updated issues`
            : 'Click to accept all current issues and warnings from DNV.';
    };

    return (
        <IssuesHeader>
            <div>
                <TextButton className="inline" isSelected={props.isShowDetails === true} onClick={() => props.onChangeShowDetails()}>
                    Show details
                </TextButton>
                <IconButton isSelected={props.sortDesc === true} onClick={() => props.onChangeSort()}>
                    <FontAwesomeIcon title="Click to change sorting" icon={props.sortDesc ? 'sort-amount-up' : 'sort-amount-down-alt'} />
                </IconButton>
            </div>
            <div>
                {canShowComponentForRole(role) && (
                    <>
                        {(selectedReportMetadata.acceptedAt && selectedReportMetadata.status == DNVReportStatus.VerifiedByDNV && (
                            <AcceptedWrapper title={getUndoAcceptTooltip(selectedReportMetadata)}>
                                <FontAwesomeIcon className="info-icon" icon="info-circle" />
                                <TextButton className="inline" onClick={() => onUndoAccept()}>
                                    Undo accept report
                                </TextButton>
                            </AcceptedWrapper>
                        )) ||
                            (selectedReportMetadata.dnvIssues?.length > 0 && (
                                <AcceptedWrapper title={getAcceptTooltip(selectedReportMetadata)}>
                                    {selectedReportMetadata.acceptedAt && <FontAwesomeIcon className="info-icon" icon="info-circle" />}
                                    <TextButton isSelected={showConfirmAccept} className="inline" onClick={() => onConfirmAccept()}>
                                        Accept report
                                    </TextButton>
                                </AcceptedWrapper>
                            ))}

                        <TextButton isSelected={isCommentExpanded} className="inline" onClick={() => onToggleComment()}>
                            Comment{' '}
                            <span>
                                <FontAwesomeIcon className="expand-icon" icon="chevron-down" />
                            </span>
                        </TextButton>
                    </>
                )}
            </div>
        </IssuesHeader>
    );
};
export default VerificationHeaderComponent;
